import {DefaultFilterPageProps} from "@models/DefaultFilterPageProps.ts";
import {IGetEmpresasFilter} from "@components/empresas/endpoints/filters/IGetEmpresaFilter.ts";
import {Grid, TextField} from '@mui/material'
import {useState} from "react";
import {CpfCnpjInput} from "@shared/custom/CpfCnpjInput.tsx";

interface EmpresasFilterComponentProps extends DefaultFilterPageProps<IGetEmpresasFilter> {
}

export function EmpresasFilterComponent(props: EmpresasFilterComponentProps) {
    const [filters, setFilters] = useState<IGetEmpresasFilter>(props.filters ?? {});
    const handleApply = () => {
        if (props.setFilters != null) props.setFilters(filters)
        if (props.onApply != null) props.onApply()
    }
    return (
        <Grid container size={12} component={'form'}
              onSubmit={handleApply}>
            <Grid size={{xs: 12, md: 6}}>
                <TextField value={filters.nome}
                           autoFocus
                           enterKeyHint={'next'}
                           onKeyDown={e => {
                               if (e.key === 'Enter') {
                                   handleApply()
                               }
                           }}
                           onChange={e => setFilters({...filters, nome: e.target.value})}
                           label={'Nome'}/>
            </Grid>
            <Grid size={{xs: 12, md: 6}}>
                <CpfCnpjInput value={filters.cnpj}
                              onEnter={handleApply}

                              slotProps={{
                                  TextField: {
                                      variant: 'filled',
                                      enterKeyHint: 'enter'
                                  }
                              }} onChange={v => setFilters({...filters, cnpj: v})}/>
            </Grid>
        </Grid>
    )
}